var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{staticClass:"mt-16",attrs:{"fluid":""}},[_vm._v(" Videography ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }